import React from 'react';
import { Checkbox } from 'rsuite';

import { Store } from '../../../../../../../reducers/OtimizacaoPrecos/optimizationPricesList';
import { Filter } from '../Filter/Filter';
import styles from './FilterStore.module.scss';

interface FilterStoreProps {
  stores: Store[];
  handleSelectStoreId: (value: any) => void;
  selectedStoresId: string[];
  storesIdWithoutResults: string[];
  cleanable?: boolean;
  disabled?: boolean;
}

export const FilterStore = ({
  handleSelectStoreId,
  stores,
  selectedStoresId,
  storesIdWithoutResults,
  cleanable = true,
  disabled = false,
}: FilterStoreProps) => {
  const allowedStores = stores.filter(item => !storesIdWithoutResults.includes(item.storeId));

  const checkedStores = selectedStoresId?.length > 0 && selectedStoresId?.length === allowedStores?.length;
  const indeterminateStores = selectedStoresId?.length > 0 && !checkedStores;
  const disabledItems = stores.filter(item => storesIdWithoutResults.includes(item.storeId)).map(item => item.storeId) as any[];
  return (
    <>
      <Filter
        style={{ maxWidth: '300px' }}
        disabledItemValues={disabledItems}
        disabled={disabled}
        isMultiple
        cleanable={cleanable}
        appearance="default"
        searchable
        placeholder={'Selecione as lojas'}
        type="select"
        name="loja"
        filter={false}
        selectedItemsId={selectedStoresId}
        data={stores.map(item => ({ label: item.storeName, value: item.storeId }))}
        onSelect={value => handleSelectStoreId(value)}
        onClean={() => handleSelectStoreId([])}
        locale={{
          noResultsText: stores.length === 0 ? 'Carregando lojas...' : 'Nenhum item encontrado',
          searchPlaceholder: 'Pesquisar lojas',
        }}
        renderMenuItem={(label, item) => {
          const isDisabled = disabledItems.includes(item.value);
          return (
            <div className={styles['render-menu-item']}>
              <span>{label}</span>
              {isDisabled && <span className={styles['no-results']}>Sem resultados disponíveis</span>}
            </div>
          );
        }}
        renderExtraFooter={() => (
          <div className={styles['render-extra-footer']}>
            <Checkbox
              block
              indeterminate={indeterminateStores}
              checked={checkedStores}
              onChange={(_v: any, checked: boolean) => {
                const nextValue = checked ? stores.filter(item => !storesIdWithoutResults.includes(item.storeId)).map(item => item.storeId) : [];
                handleSelectStoreId(nextValue);
              }}
            >
              Selecionar todas as lojas
            </Checkbox>
          </div>
        )}
      />
    </>
  );
};
